import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import AppButton from '@/shared/ui/AppButton';

interface Props {
  onContinue: () => void;
  onCancel: () => void;
}

/**
 * Asked only when the browser blocked Google's sign-in window: a window may open only right after a click, and this
 * button is that click.
 */
const GoogleSignInDialog: FC<Props> = ({ onContinue, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Dialog open onClose={onCancel} maxWidth="xs" data-testid="drive-sign-in-dialog">
      <DialogTitle>{t('artwork_drive.upload.sign_in_title')}</DialogTitle>
      <DialogContent>
        <Typography variant="body2">{t('artwork_drive.upload.sign_in_body')}</Typography>
      </DialogContent>
      <DialogActions>
        <AppButton variant="secondary" onClick={onCancel}>
          {t('buttons.cancel')}
        </AppButton>
        <AppButton variant="primary" onClick={onContinue}>
          {t('artwork_drive.upload.continue_with_google')}
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default GoogleSignInDialog;
